<template>
  <li>
    <a :class="{ 'is-active': current === category.id }" class="has-toggle"
      @click="$emit('update:current', category.id)">

      <div @click.stop="expand = !expand">
        <b-icon :icon="expand ? 'minus-square' : 'plus-square'" />
      </div>
      {{ $t('proprio.id' + category.id )  }}
    </a>
    <ul v-if="expand">
      <li v-for="item in category.subCategories" :key="item.id">
        <a :class="{ 'is-active': current === item.id }" @click="$emit('update:current', item.id)">
          {{ item.name }}
        </a>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  props: {
    category: {
      type: Object,
      required: true,
    },
    current: {
      type: Number,
      default: () => null,
    },
  },
  data () {
    return {
      expand: false,
    }
  },
  watch: {
    current (value) {
      console.log('toogle')
      if (value === this.category.id) {
        this.expand = true
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
